import {
  index,
  integer,
  pgTable,
  serial,
  text,
  unique,
} from "drizzle-orm/pg-core";
import { createSchemaFactory } from "drizzle-zod";
import { z } from "zod";

import { users } from "./auth";
import { playerProfiles } from "./player-profiles";
import { timestamps } from "./shared";
import { tournamentDivisions } from "./tournament-divisions";

const { createSelectSchema } = createSchemaFactory({ zodInstance: z });

export const tournamentPlayerCheckIns = pgTable(
  "tournament_player_check_ins",
  {
    id: serial().primaryKey(),
    tournamentDivisionId: integer()
      .notNull()
      .references(() => tournamentDivisions.id, { onDelete: "cascade" }),
    playerProfileId: integer()
      .notNull()
      .references(() => playerProfiles.id, { onDelete: "cascade" }),
    checkedInBy: text().references(() => users.id, { onDelete: "set null" }),
    method: text().notNull().default("self"),
    ...timestamps,
  },
  (table) => [
    unique("tournament_player_check_in_unique").on(
      table.tournamentDivisionId,
      table.playerProfileId,
    ),
    index("tpci_division_idx").on(table.tournamentDivisionId),
    index("tpci_player_idx").on(table.playerProfileId),
    index("tpci_checked_in_by_idx").on(table.checkedInBy),
  ],
);

export const selectTournamentPlayerCheckInSchema = createSelectSchema(
  tournamentPlayerCheckIns,
);

export type TournamentPlayerCheckIn = z.infer<
  typeof selectTournamentPlayerCheckInSchema
>;
